import axios from 'axios';
import { jwtDecode } from 'jwt-decode';

interface DecodedToken {
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier': string;
  'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name': string;
  'http://schemas.microsoft.com/ws/2008/06/identity/claims/role': string | string[];
  exp: number;
}

interface QueryTokenPayload {
  email?: string;
  applicationId?: string;
  exp: number;
  [key: string]: any;
}


const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '';

const register = (data: any) => {
  return axios.post(apiBaseUrl + '/Auth/register', data);
};

const login = async (data: any, setToken: (token: string, refreshToken: string) => void) => {
  const response = await axios.post(`${apiBaseUrl}/Auth/login`, data);
  if (response.data.token) {
    setToken(response.data.token, response.data.refreshToken);
  }
  return response.data;
};

const logout = (setToken: (token: string | null, refreshToken: string | null) => void) => {
  setToken(null, null);
};
const getCurrentUser = () => {
  
  const token = localStorage.getItem('token');
  if (token) {
    const decodedToken = jwtDecode<DecodedToken>(token);
    return {
      id: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'],
      name: decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'] || '',
      roles: decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'],
      exp: decodedToken.exp,
    };
  }
  return null;
};

const validateQueryToken = (token: string, applicationId: string): { isValid: boolean; payload?: QueryTokenPayload } => {
  try {
    const decoded = jwtDecode<QueryTokenPayload>(token);
    
    // Check if token is expired
    if (decoded.exp && decoded.exp < Date.now() / 1000) {
      return { isValid: false };
    }
    
    // Check for required claims
    if (decoded.nameid && decoded.applicationId) {
      if(decoded.applicationId == applicationId)
      {
        return { isValid: true, payload: decoded };
      }
    }
    
    return { isValid: false };
  } catch (error) {
    console.error('Invalid JWT token:', error);
    return { isValid: false };
  }
};

const hasRequiredRole = (requiredRoles: string[]): boolean => {
  const currentUser = getCurrentUser();
  if (!currentUser || !currentUser.roles) {
    return false;
  }
  
  // Check if token is expired
  if (currentUser.exp < Date.now() / 1000) {
    return false;
  }
  
  const userRoles = Array.isArray(currentUser.roles) ? currentUser.roles : [currentUser.roles];
  return requiredRoles.some(role => userRoles.includes(role));
};

const isAuthorizedForI9Form = (queryToken?: string, applicationId?: string): boolean => {
  const allowedRoles = ['HRManager', 'CFO', 'Admin'];
  
  // Check query string token first
  if (queryToken) {
    const { isValid } = validateQueryToken(queryToken, applicationId || '');
    return isValid;
  }
  
  // Check if user has required roles
  return hasRequiredRole(allowedRoles);
};

const authService = {
  register,
  login,
  logout,
  getCurrentUser,
  validateQueryToken,
  hasRequiredRole,
  isAuthorizedForI9Form
};

export default authService;
